import React from "react";
import { Link } from "react-router-dom";

function Back(props) {
  var numPages = props.pages ? -props.pages : -1;
  var uri = props.uri;
  return (
    <button
      type="button"
      className="btn btn-sm btn-secondary nonPrintable"
      onClick={() => {
		  if (uri) window.location.href = uri; else window.history.go(numPages);
	  }}
    >
      &lt; Go Back
    </button>
  );
}

export default Back;
